import { render } from "./ClaseSiCategorii.vue?vue&type=template&id=87a73df8&ts=true"
import script from "./ClaseSiCategorii.vue?vue&type=script&lang=ts"
export * from "./ClaseSiCategorii.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__